<div class="modal-header" *ngIf="title">
  <h4 class="modal-title pull-left">{{ title }}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  {{content}}
</div>
<div class="modal-footer" *ngIf="closeBtnName">
  <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">{{ closeBtnName }}</button>
</div>
